import InstructionAuthorisationEndpoints from './microserviceEndpoints/instructionAuthorisation';
import CalendarManagementEndpoints from './microserviceEndpoints/calendarManagementEndpoints';
import BacsManagementEndpoint from './microserviceEndpoints/bacsManagement';
import BenificiaryManagementEndpoints from './microserviceEndpoints/benificiaryManagement';
import TemplateManagementEndpoints from './microserviceEndpoints/templateManagement';
import InternationalFundsTransferInstructionAuthorisationEndpoints from './microserviceEndpoints/internationalFundsTransferInstructionAuthorisation';
import MultipartBatchEndpoints from './microserviceEndpoints/multipartBatch';
import PaymentInformationEndpoints from './microserviceEndpoints/paymentInformation';
import RatesManagementEndpoints from './microserviceEndpoints/ratesManagement';
import limitsManagement from './microserviceEndpoints/limitsManagement';
import biocatchManagement from './microserviceEndpoints/biocatchEndpoint';
import chapsManagement from './microserviceEndpoints/chapsManagement';
import accounts from './microserviceEndpoints/accounts';
import effectiveWarningEndpoints from './microserviceEndpoints/effectiveWarning';
import kapitiTransactions from './microserviceEndpoints/kapitiTransactions';
import cop from './microserviceEndpoints/cop';
import srdVerification from './microserviceEndpoints/srdVerification';

const endpoints = {
	...InstructionAuthorisationEndpoints,
	...PaymentInformationEndpoints,
	...MultipartBatchEndpoints,
	...InternationalFundsTransferInstructionAuthorisationEndpoints,
	...TemplateManagementEndpoints,
	...BenificiaryManagementEndpoints,
	...CalendarManagementEndpoints,
	...BacsManagementEndpoint,
	...RatesManagementEndpoints,
	...limitsManagement,
	...biocatchManagement,
	...chapsManagement,
	...accounts,
	...effectiveWarningEndpoints,
	...kapitiTransactions,
	...cop,
	...srdVerification,
};

export default endpoints;
